import React from 'react';
import { withRedux } from "helpers";

function HasPermission({
  permission,
  activeApp,
  userApplicationsPermissions,
  children,
  appId,
  requiredPermissions,
  fallback
}) {
  const permissions = appId ? userApplicationsPermissions[appId] : userApplicationsPermissions[activeApp.id];

  if(!permissions || permissions.length === 0) {
    return fallback || null;
  }

  if(requiredPermissions) {
    return requiredPermissions.some(id => permissions.includes(id)) && children;
  }
  
  if (
    permission === 'pass' || 
    permissions.includes(permission) ||
    permissions.includes(0)
    ){
    return children;
  }


  return fallback || null;
}

export default withRedux(HasPermission);